import script from "./UserRewards.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRewards.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__